import React, { Fragment } from 'react'
import Link from 'gatsby-link'

import FeaturesList from '~/components/pages/FeaturesList'

const FEATURES = [
  {
    icon: 'chain',
    title: 'Third party integrations',
    text: (
      <Fragment>
        Botpress features connectors to all the major chat platforms that you’d
        expect. See{' '}
        <Link to="/features/supported-platforms">supported platforms</Link>.
      </Fragment>
    ),
  },
  {
    icon: 'comments-o',
    title: 'Conversation flow manager',
    text:
      'Easily view, manage, updated and extend how a bot’s conversation should progress based on user inputs.',
  },
  {
    icon: 'language',
    title: 'Multiple language engines',
    text:
      'Link in the natural language understanding solutions that best suit you—no need to be tied to one option.',
  },
  {
    icon: 'exchange',
    title: 'Content & flow separation',
    text:
      'A flagship feature which decouples your bots’ content and flow management so they can be managed by different teams, and allows content managers to see a visual representation of their markup as faux chats in real time.',
  },
  {
    icon: 'filter',
    title: 'Marketing tools baked in',
    text:
      'Botpress features functionality like tagged market segmentation and A/B testing to let you better track customer experiences, and connect them into your broader marketing strategy.',
  },
  {
    icon: 'area-chart',
    title: 'Analytics',
    text:
      'Every bot platform should have analytics built in, and Botpress is no exception. Assess user engagement with your bots, identify successes to build on, and spot failures to correct.',
  },
  {
    icon: 'user-plus',
    title: 'Human in the loop',
    text:
      'Botpress allows human agents to take over the bot, or drop in on the chat if the flow of conversation moves beyond the bot’s capabilities.',
  },
  {
    icon: 'puzzle-piece',
    title: 'Modular design',
    text:
      'Assemble your bot from our collection of specialized, open-source modules that do one thing very well.',
  },
  {
    icon: 'github-alt',
    title: 'Open source',
    text:
      'We chose an open-source, dual-license, free-to-most-users approach to boost transparency and collaboration.',
  },
  {
    icon: 'object-group',
    title: 'Graphical interface',
    text:
      'You shouldn’t have to choose between CLI or GUI. Every feature is available as an API and as a rich graphical interface.',
  },
  {
    icon: 'wrench',
    title: 'For devs, by devs',
    text:
      'React. Webpack. ES7. We use modern tools you already use and like, and we keep things simple.',
  },
  {
    icon: 'wrench',
    title: 'Extensible',
    text:
      'Easily build more components for bots, and add to the growing pool of common features that are available to developers.',
  },
]

const Features = () => <FeaturesList features={FEATURES} />

export default Features



// WEBPACK FOOTER //
// ./src/components/pages/features/overview/Features.js